import 'core-js/stable';

async function load() {
    window._ = await import(/* webpackMode: "eager" */ 'underscore');
    await import(/* webpackMode: "eager" */ './history/events');
}

async function loadAfterDOM() {
    await import(/* webpackMode: "eager" */ './analytics/analytics');
    await import(/* webpackMode: "eager" */ './navigation/navigation');
    await import(/* webpackMode: "eager" */ './navigation/blog-navigation');
    await import(/* webpackMode: "eager" */ './language_bar/language-bar');
    await import(/* webpackMode: "eager" */ './footer/footer');
    await import(/* webpackMode: "eager" */ './script_loader/script-loader');
    await import(/* webpackMode: "eager" */ './user_context/user-context');
    await import(/* webpackMode: "eager" */ './saved_configuration/save-configuration');
    await import(/* webpackMode: "eager" */ './image_fallback/image-fallback');
}

load();
document.addEventListener('DOMContentLoaded', () => {
    loadAfterDOM();
});
